"use strict";
// (C) 2007-2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.dateFilterValueToDateRange = exports.dateRangeToDateFilterValue = void 0;
var DateConversions_1 = require("../utils/DateConversions");
var Platform_1 = require("../constants/Platform");
exports.dateRangeToDateFilterValue = function (range, localIdentifier, isTimeForAbsoluteRangeEnabled) {
    var parsingFormat = isTimeForAbsoluteRangeEnabled ? Platform_1.platformDateTimeFormat : Platform_1.platformDateFormat;
    return {
        from: DateConversions_1.convertDateToPlatformDateString(range.from, parsingFormat),
        to: DateConversions_1.convertDateToPlatformDateString(range.to, parsingFormat),
        localIdentifier: localIdentifier,
        type: "absoluteForm",
        name: "",
        visible: true,
    };
};
exports.dateFilterValueToDateRange = function (value, isTimeForAbsoluteRangeEnabled) {
    if (isTimeForAbsoluteRangeEnabled === void 0) { isTimeForAbsoluteRangeEnabled = false; }
    var isFromTimeDefined = value.from && value.from.split(" ").length > 1;
    var isToTimeDefined = value.to && value.to.split(" ").length > 1;
    var from = value && DateConversions_1.convertPlatformDateStringToDate(value.from);
    var to = value && DateConversions_1.convertPlatformDateStringToDate(value.to);
    if (from && !isFromTimeDefined && isTimeForAbsoluteRangeEnabled) {
        from.setHours(0);
        from.setMinutes(0);
    }
    if (to && !isToTimeDefined && isTimeForAbsoluteRangeEnabled) {
        to.setHours(23);
        to.setMinutes(59);
    }
    return { from: from, to: to };
};
//# sourceMappingURL=conversions.js.map